import { MetricsIcon, DashboardIcon, MapIcon, TasksIcon, TemplatesIcon, TimelineIcon, JournalIcon } from '../icons'

export const formatBytes = (bytes) => {
  if (bytes == null) return null
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(2)} MB`
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`
}

// optOut: true  → show unless flag is explicitly false (opt-out)
// optOut: false/absent → show only when flag is explicitly true (opt-in)
export const menuItems = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard', requiresFarm: true },
  { text: 'Timeline', icon: <TimelineIcon />, path: '/timeline', requiresFarm: true, requires: 'page_timeline', optOut: true },
  { text: 'Map', icon: <MapIcon />, path: '/map', requiresFarm: true, requires: 'page_map', optOut: true },
  { text: 'Tasks', icon: <TasksIcon />, path: '/tasks', requiresFarm: true, requires: 'page_tasks', optOut: true },
  { text: 'Metrics', icon: <MetricsIcon />, path: '/metrics', requiresFarm: true, requires: 'page_metrics', optOut: true },
  { text: 'Templates', icon: <TemplatesIcon />, path: '/templates', requiresFarm: false, requires: 'page_templates', optOut: true },
  { text: 'Journal', icon: <JournalIcon />, path: '/journal', requiresFarm: true, requires: 'page_journal', optOut: true },
]
